import React from 'react';
import { NumericFormat } from 'react-number-format';
import CheckBox from '../../components/CheckBox';
import PopupInput from '../../components/PopupInput';
import PopupDropdown from '../../components/PopupDropdown';
import { MdDelete, MdAttachMoney } from "react-icons/md";

const FreeLineOrderLine = ({
  orderLine,
  categoryIndex,
  orderLineIndex,
  templateMode,
  isEditable = true,
  handleIndividualProductChange,
  handleGroupInputChange,
  handleNotesChange,
  handleStatusChange,
  handleDeleteOrderLine,
  statusOptions,
  statusLabelColors,
  convertVatToPercentage,
  convertDecimalToPercentage,
  convertPercentageToDecimal,
  convertPercentageToVat
}) => {
  return (
    <div className={`product_category--order_line free-line ${templateMode ? 'template-mode' : 'normal-mode'}`}>
      <div className='product_category--order_line_name no-border'>
        <div className="product-display-container">
          <div className="product-display-main">
            {categoryIndex + 1}.{orderLineIndex + 1} {orderLine.free_product_brand ? `${orderLine.free_product_brand} - ` : ""}{orderLine.free_product_name}
          </div>
          <div className="product-display-details">
            {orderLine.free_product_description && (
              <span className="product-description">{orderLine.free_product_description}</span>
            )}
          </div>
        </div>
      </div>
      <div className='product_category--order_line_name'>
        <NumericFormat
          value={orderLine.quantity}
          onValueChange={(values) => handleIndividualProductChange(
            categoryIndex,
            orderLineIndex,
            'quantity',
            values.value
          )}
          className="order-line-input"
          disabled={!isEditable}
        />
      </div>
      <div className='product_category--order_line_name'>
        <NumericFormat
          value={orderLine.quantity_margin || 0}
          suffix="%"
          onValueChange={(values) => handleIndividualProductChange(
            categoryIndex,
            orderLineIndex,
            'quantity_margin',
            values.value
          )}
          className="order-line-input"
          disabled={!isEditable}
        />
      </div>
      <div className='product_category--order_line_name'>
        <NumericFormat
          value={orderLine.quantity_total}
          displayType="input"
          decimalScale={2}
          readOnly
          className="order-line-input"
        />
      </div>
      <div className='product_category--order_line_name'>
        <CheckBox
          margin={"5px 0 5px 25%"}
          state={orderLine.is_chosen_option || false}
          setState={(value) => handleIndividualProductChange(
            categoryIndex,
            orderLineIndex,
            'is_chosen_option',
            value
          )}
          disabled={!isEditable}
        />
      </div>
      {/* No alternatives for free lines */}
      {!templateMode && (
        <div className='product_category--order_line_name'></div>
      )}
      <div className='product_category--order_line_name centered'></div>
      {/* Template-specific fields - only show when in template mode */}
      {templateMode && (
        <>
          <div className='product_category--order_line_name'></div>
          <div className='product_category--order_line_name'></div>
          <div className='product_category--order_line_name'></div>
          <div className='product_category--order_line_name'></div>
          <div className='product_category--order_line_name'>
            <CheckBox
              margin={"5px 0 5px 25%"}
              state={orderLine.is_hidden_for_client}
              setState={(value) => {
                handleGroupInputChange(
                  categoryIndex,
                  orderLineIndex,
                  'is_hidden_for_client',
                  value,
                  false
                );
              }}
              disabled={!templateMode || !isEditable}
            />
          </div>
        </>
      )}
      <div className='product_category--order_line_name'>
        <select
          aria-label="VAT rate"
          value={Number(orderLine.vat_percentage ?? 0.21)}
          onChange={event => handleGroupInputChange(categoryIndex, orderLineIndex, 'vat_percentage', Number(event.target.value), false)}
          className="order-line-input"
          disabled={!isEditable}
        >
          {[0, 0.06, 0.12, 0.21].map(rate => <option key={rate} value={rate}>{rate * 100}%</option>)}
        </select>
      </div>
      <div className='product_category--order_line_name'>
        <NumericFormat
          value={convertDecimalToPercentage(orderLine.discount_percentage || 0)}
          suffix="%"
          onValueChange={(values) => handleIndividualProductChange(
            categoryIndex,
            orderLineIndex,
            'discount_percentage',
            convertPercentageToDecimal(values.value)
          )}
          className="order-line-input"
          disabled={!isEditable}
        />
      </div>
      <div className='product_category--order_line_name'>
        {isEditable ? (
          <PopupInput
            title="Notes"
            fields={[
              { id: 'note_client', label: 'Client Note', placeholder: 'Add note for client...' },
              { id: 'note_supplier', label: 'Supplier Note', placeholder: 'Add note for supplier...' }
            ]}
            values={{
              note_client: orderLine.note_client || '',
              note_supplier: orderLine.note_supplier || ''
            }}
            onChange={(notes) => handleNotesChange(categoryIndex, orderLineIndex, notes)}
            width="700px"
            height="auto"
          />
        ) : (
          <span>Notes</span>
        )}
      </div>

      <div className='product_category--order_line_name actions'>        
        <div className="price-section">
          {orderLine.is_chosen_option && orderLine.free_price && orderLine.free_price > 0 ? (
            <div className={`selected-price-display ${orderLine.free_price >= 0 ? 'price-positive' : 'price-negative'}`}>
              <div className="price-main">
                €{parseFloat(orderLine.free_price).toFixed(2)}
              </div>
              <div className="price-actions">
                {isEditable ? (
                  <PopupInput
                    title="Change price"
                    fields={[
                      { id: 'price', label: 'Price', placeholder: 'Enter price...', type: 'number' }
                    ]}
                    values={{
                      price: orderLine.free_price || ''
                    }}
                    onChange={(values) => handleIndividualProductChange(
                      categoryIndex,
                      orderLineIndex,
                      'free_price',
                      values.price
                    )}
                    width="400px"
                    height="auto"
                    customButton={
                      <button
                        className="icon-button change-price-button"
                        title="Change price"
                      >
                        <MdAttachMoney />
                      </button>
                    }
                  />
                ) : null}
              </div>
            </div>
          ) : orderLine.is_chosen_option && isEditable && (
            <PopupInput
              title="Set price"
              fields={[
                { id: 'price', label: 'Price', placeholder: 'Enter price...', type: 'number' }
              ]}
              values={{
                price: orderLine.free_price || ''
              }}
              onChange={(values) => handleIndividualProductChange(
                categoryIndex,
                orderLineIndex,
                'free_price',
                values.price
              )}
              width="400px"
              height="auto"
              customButton={
                <button
                  className={`icon-button price-button price-not-assigned`}
                  title="No price assigned - click to set price"
                >
                  <MdAttachMoney />
                </button>
              }
            />
          )}
        </div>
        <button
          className='icon-button delete-button'
          onClick={() => handleDeleteOrderLine(categoryIndex, orderLineIndex)}
          title="Delete product"
          disabled={!isEditable}
        >
          <MdDelete />
        </button>
      </div>
    </div>
  );
};

export default FreeLineOrderLine; 
